import { useEffect, useState } from "react";
import { all_routes } from "../../router/all_routes";
import { Link } from "react-router-dom";
import Table from "../../../core/common/dataTable/index";
import CommonSelect from "../../../core/common/commonSelect";
import CollapseHeader from "../../../core/common/collapse-header/collapse-header";
import api from "../../../services/api";
import Loader from "../../../core/common/loader";
import { showBasicAlert } from "../../../core/common/useAlert";
import DeleteModal from "../../../core/modals/deleteModal";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import * as XLSX from "xlsx";
import EmployeeDetailsModal from "./EmployeeDetailsModal";

const Designations = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [menuSubMenu, setmenuSubMenu] = useState<any[]>([]);
  const [showEmployeeModal, setShowEmployeeModal] = useState(false);
  const [selectedUsers, setSelectedUsers] = useState<any[]>([]);
  const [selectedDesignation, setSelectedDesignation] = useState("");
  const status = [
    { value: "Active", label: "Active" },
    { value: "Inactive", label: "Inactive" },
  ];

  const signature = localStorage.getItem("signature");

  //Add Designation Start
  const addDesignationInitialFormData = {
    designationName: "",
    departmentId: "",
    status: "",
  };

  const [addDesignationFormData, setaddDesignationFormData] = useState(
    addDesignationInitialFormData
  );

  const handleDepartmentNameChange = (e: any) => {
    const { name, value } = e.target;
    setaddDesignationFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };


  const handleEmployeeClick = (users: any[], designation: string) => {
    setSelectedUsers(users);
    setSelectedDesignation(designation);
    setShowEmployeeModal(true);
  };

  useEffect(() => {
    // This will run when the component mounts
    const fetchDepartmentData = async () => {
      try {
        setIsLoading(true);
        await updateUI();
        setIsLoading(false); // hide loader after response
      } catch (err: any) {
        setIsLoading(false); // hide loader after response
        showBasicAlert(err.data.message[0].msg);
        console.error("Error fetching dashboard data:", err);
      }
    };
    fetchDepartmentData();
  }, []);

  const handleAddDesignation = async () => {
    // Validation logic here (e.g., required fields, file size)
    if (
      !addDesignationFormData.departmentId ||
      !addDesignationFormData.designationName ||
      !addDesignationFormData.status
    ) {
      showBasicAlert("Please fill all required fields.");
      return;
    }

    // Post data to API
    try {
      const dataToSend = {
        signature: signature,
        designationName: addDesignationFormData.designationName,
        departmentId: addDesignationFormData.departmentId,
        status:
          addDesignationFormData.status.toLowerCase() === "active" ? 1 : 0,
        menuSubMenu: selectedData,
      };
      try {
        setIsLoading(true);
        const response = await api.post(
          "userService/addDesignation",
          dataToSend
        );
        setaddDesignationFormData(addDesignationInitialFormData);
        setSelectedData([
          {
            menu: "",
            sub_menus: [],
          },
        ]);
        await updateUI();
        setIsLoading(false); // hide loader after response
        showBasicAlert(response.data.message[0].msg);
      } catch (error: any) {
        setIsLoading(false); // hide loader after response
        showBasicAlert(error.data.message[0].msg);
      }
    } catch (error) {
      console.error("Error adding Tax:", error);
      showBasicAlert("An error occurred. Please try again.");
    }
  };

  //Add Designation End
  const [departmentName, setdepartmentName] = useState<any[]>([]);
  const [data, setData] = useState<any[]>([]);
  const [filteredData, setFilteredData] = useState(data);

  const updateUI = async () => {
    const [getDepartment, getDesignation, menuSubMenu] = await Promise.all([
      api.post("userService/getDepartment", { signature }),
      api.post("userService/getDesignationWithUser", { signature }),
      api.post("userService/getCompanyMenuSubMenu", { signature }),
    ]);
    setdepartmentName(getDepartment.data.data.data);
    setData(getDesignation.data.data.data);
    setFilteredData(getDesignation.data.data.data);
    setmenuSubMenu(menuSubMenu.data.data.data);
    return;
  };

  //Filters Start
  const [departmentFilter, setDepartmentFilter] = useState<string | null>(null);
  const [statusFilter, setStatusFilter] = useState<string | null>(null);
  const [sortBy, setSortBy] = useState<string | null>(null);

  const handleReset = () => {
    setFilteredData(data);
    setStatusFilter(null);
    setDepartmentFilter(null);
    setSortBy(null);
  };

  useEffect(() => {
    if (filteredData) {
      var newFilteredData = data
        .filter((item: any) => {
          if (
            statusFilter &&
            item.Status.toLowerCase() !== statusFilter.toLowerCase()
          ) {
            return false;
          }
          if (departmentFilter && item.Department !== departmentFilter) {
            return false;
          }

          return true;
        })
        .sort((a: any, b: any) => {
          switch (sortBy) {
            case "Ascending":
              return a.Designation.localeCompare(b.Designation);
            case "Descending":
              return b.Designation.localeCompare(a.Designation);
            default:
              return a.Designation.localeCompare(b.Designation);
          }
        });
      var dateFilter = [...newFilteredData];
      if (dateFilter.length > 0) {
        setFilteredData(dateFilter); // Update filtered data
      } else {
        if (data.length > 0) {
          showBasicAlert("No Data");
        }
      }
    }
  }, [statusFilter, sortBy, departmentFilter]);
  //Filter End

  //Edit Designation Start
  const [selectedDesignationEdit, setSelectedDesigntionEdit] = useState<
    any | null
  >(null);
  const handleDesignationEdit = (record: any) => {
    try {
      setSelectedDesigntionEdit(record);

      // Ensure menu and permissions are correctly mapped
      const formattedData: SelectedData[] = record.menu.map(
        (menuItem: string) => {
          const menuPermissions = record.permissions.filter(
            (p: any) => record.menu.includes(menuItem) // Match menu items
          );

          return {
            menu: menuItem, // Main menu (e.g., CRM)
            sub_menus: menuPermissions.map((subMenu: any) => ({
              name: subMenu.name, // Submenu name (e.g., Deals, Leads)
              permissions: subMenu.permissions || [], // ["Read"]
            })),
          };
        }
      );

      setSelectedData(formattedData); // Set selected checkboxes
    } catch (e) {
      console.log("Error in handleDesignationEdit:", e);
    }
  };

  const handleEditSaveChanges = async () => {
    try {
      const permissionsToSave = selectedData.map((item) => ({
        name: item.menu, // Each menu (CRM, Sales, etc.)
        permissions: item.sub_menus.map((sub) => ({
          name: sub.name,
          permissions: sub.permissions,
        })),
      }));

      const uniqueMenu = Array.from(
        new Set(selectedData.map((item) => item.menu))
      );

      const uniqueMenuItems = Array.from(
        new Set(
          selectedData.flatMap((item) => item.sub_menus.map((s) => s.name))
        )
      );

      const permissionMap: any = {};

      permissionsToSave
        .flatMap((menu) => menu.permissions)
        .forEach(({ name, permissions }) => {
          if (!permissionMap[name]) {
            permissionMap[name] = new Set();
          }
          permissions.forEach((p) => permissionMap[name].add(p));
        });

      const mergedPermissions = Object.entries(permissionMap).map(
        ([name, perms]: any) => ({
          name,
          permissions: Array.from(perms),
        })
      );

      const body = {
        signature: signature,
        Designation: selectedDesignationEdit.Designation,
        Department: selectedDesignationEdit.Department,
        status: selectedDesignationEdit.Status,
        id: selectedDesignationEdit.key,
        menu: uniqueMenu, // Array of menus
        menu_items: uniqueMenuItems, // Flattened array of submenus
        permissions: mergedPermissions, // Flatten permissions
      };

      try {
        setIsLoading(true);
        await api.post("userService/editDesignation", body);
        setIsLoading(false); // hide loader after response
        // showBasicAlert(response.data.message[0].msg);
        window.location.reload();
      } catch (error: any) {
        setIsLoading(false); // hide loader after response
        showBasicAlert(error.data.message[0].msg);
      }
    } catch (error) {
      console.error("Error updating company details:", error);
      showBasicAlert("An error occurred. Please try again.");
    }
  };
  //Edit Designation End

  //Delete Department Start
  const [deleteRecord, setDeleteRecord] = useState<{
    key: number;
    name: string;
  } | null>(null);

  const handleDelete = async () => {
    if (deleteRecord) {
      try {
        var designation_id = deleteRecord.key;
        try {
          setIsLoading(true);
          const response = await api.post("userService/deleteDesignation", {
            signature,
            designation_id,
          });
          await updateUI();
          setIsLoading(false); // hide loader after response
          showBasicAlert(response.data.message[0].msg);
        } catch (error: any) {
          setIsLoading(false); // hide loader after response
          showBasicAlert(error.data.message[0].msg);
        }
      } catch (error) {
        console.error("Error deleting item:", error);
        alert("Failed to delete item.");
      }
      setDeleteRecord(null);
    }
  };
  //Delete Department End

  //Exort Data Handle function Start
  const handleExportPDF = () => {
    const doc = new jsPDF();

    // Example columns
    const columns = ["Designation", "Department", "No Of Employees", "Status"];
    const tableData: (string | number)[][] = filteredData.map((item) => [
      item.Designation, // Assuming the first element is a number (ID)
      item.Department, // Assuming the second element is a string (Company name)
      item.NoOfEmployees, // Email (string)
      item.Status, // Status (string)
    ]);
    // Generate the table in the PDF (no need to pass `doc` as the first argument anymore)
    doc.autoTable({
      head: [columns],
      body: tableData,
    });

    // Save the PDF
    doc.save("designaions.pdf");
  };
  const handleExportExcel = () => {
    const ws = XLSX.utils.json_to_sheet(filteredData); // Convert JSON to sheet
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Sheet1");

    XLSX.writeFile(wb, "designaions.xlsx");
  };
  //Exort Data Handle function End

  const columns = [
    {
      title: "Designation",
      dataIndex: "Designation",
      render: (text: String, record: any) => (
        <h6 className="fw-medium fs-14 text-dark">{text}</h6>
      ),
      sorter: (a: any, b: any) => a.Designation.length - b.Designation.length,
    },
    {
      title: "Department",
      dataIndex: "Department",
      sorter: (a: any, b: any) => a.Department.length - b.Department.length,
    },
    {
      title: "No of Employees",
      dataIndex: "NoOfEmployees",
      render: (count: number, record: any) => (
        <span
          onClick={() =>
            count > 0 && handleEmployeeClick(record.users || [], record.Designation)
          }
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: '6px',
            padding: '4px 10px',
            borderRadius: '20px',
            fontSize: '13px',
            fontWeight: 600,
            cursor: count > 0 ? 'pointer' : 'default',
            backgroundColor: count > 0 ? '#e7f1ff' : '#f1f3f5',
            color: count > 0 ? '#0d6efd' : '#868e96',
            border: count > 0 ? '1px solid #cfe2ff' : '1px solid #dee2e6',
          }}
        >
          <i className="ti ti-users" style={{ fontSize: '14px' }} />
          {count}
        </span>
      ),
      sorter: (a: any, b: any) => a.NoOfEmployees - b.NoOfEmployees,
    },
    {
      title: "Status",
      dataIndex: "Status",
      render: (text: string, record: any) => (
        <span
          className={`badge ${text === "Active" ? "badge-success" : "badge-danger"
            } d-inline-flex align-items-center badge-xs`}
        >
          <i className="ti ti-point-filled me-1" />
          {text}
        </span>
      ),
      sorter: (a: any, b: any) => a.Status.length - b.Status.length,
    },
    {
      title: "",
      dataIndex: "actions",
      render: (text: String, record: any) => (
        <div className="action-icon d-inline-flex">
          <Link
            to="#"
            className="me-2"
            data-bs-toggle="modal"
            data-inert={true}
            data-bs-target="#edit_designation"
            onClick={() => handleDesignationEdit(record)}
            title="Edit"
          >
            <i className="ti ti-edit" />
          </Link>
          <Link
            to="#"
            data-bs-toggle="modal"
            data-inert={true}
            data-bs-target="#delete_modal"
            onClick={() => setDeleteRecord(record)}
            title="Delete"
          >
            <i className="ti ti-trash" />
          </Link>
        </div>
      ),
    },
  ];
  const departmentChoose = [
    ...departmentName.map((department) => ({
      value: department.key,
      label: department.Department,
    })),
  ];

  interface SubMenu {
    name: string;
    permissions: string[];
  }

  interface SelectedData {
    menu: string;
    sub_menus: SubMenu[];
  }

  const [selectedData, setSelectedData] = useState<SelectedData[]>([]);

  const handleMenuCheckbox = (menu: any) => {
    setSelectedData((prev) => {
      const exists = prev.some((item) => item.menu === menu.title);
      if (exists) {
        return prev.filter((item) => item.menu !== menu.title);
      } else {
        return [...prev, { menu: menu.title, sub_menus: [] }];
      }
    });
  };

  const handleSubMenuCheckbox = (menu: any, subMenu: any) => {
    setSelectedData((prev: any) => {
      return prev.map((item: any) => {
        const subMenuExists = item.sub_menus.some(
          (s: any) => s.name === subMenu
        );
        if (subMenuExists) {
          // remove subMenu from all menus where it exists
          return {
            ...item,
            sub_menus: item.sub_menus.filter((s: any) => s.name !== subMenu),
          };
        } else {
          // add subMenu to all menus (only if it's the targeted one)
          if (item.menu === menu.title) {
            return {
              ...item,
              sub_menus: [
                ...item.sub_menus,
                { name: subMenu, permissions: [] },
              ],
            };
          }
        }
        return item;
      });
    });
  };

  const handlePermissionChange = (menu: any, subMenu: any, permission: any) => {
    setSelectedData((prev) =>
      prev.map((item) => {
        return {
          ...item,
          sub_menus: item.sub_menus.map((s: any) => {
            if (s.name === subMenu) {
              const newPermissions = s.permissions.includes(permission)
                ? s.permissions.filter((p: any) => p !== permission)
                : [...s.permissions, permission];
              return { ...s, permissions: newPermissions };
            }
            return s;
          }),
        };
      })
    );
  };

  return (
    <>
      {isLoading && <Loader />}

      {/* Page Wrapper */}
      <div className="page-wrapper">
        <div className="content">
          {/* Breadcrumb */}
          <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
            <div className="my-auto mb-2">
              <h2 className="mb-1">Designations</h2>
              <nav>
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link to={all_routes.adminDashboard}>
                      <i className="ti ti-smart-home" />
                    </Link>
                  </li>
                  <li className="breadcrumb-item">Employee</li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Designations
                  </li>
                </ol>
              </nav>
            </div>
            <div className="d-flex my-xl-auto right-content align-items-center flex-wrap ">
              <div className="me-2 mb-2">
                <div className="dropdown">
                  <Link
                    to="#"
                    className="dropdown-toggle btn btn-white d-inline-flex align-items-center"
                    data-bs-toggle="dropdown"
                  >
                    <i className="ti ti-file-export me-1" />
                    Export
                  </Link>
                  <ul className="dropdown-menu  dropdown-menu-end p-3">
                    <li>
                      <Link
                        to="#"
                        className="dropdown-item rounded-1"
                        onClick={handleExportPDF}
                      >
                        <i className="ti ti-file-type-pdf me-1" />
                        Export as PDF
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="#"
                        className="dropdown-item rounded-1"
                        onClick={handleExportExcel}
                      >
                        <i className="ti ti-file-type-xls me-1" />
                        Export as Excel{" "}
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="mb-2">
                <Link
                  to="#"
                  data-bs-toggle="modal"
                  data-bs-target="#add_designation"
                  className="btn btn-primary d-flex align-items-center"
                  onClick={() => {
                    setSelectedData([]);
                  }}
                >
                  <i className="ti ti-circle-plus me-2" />
                  Add Desingation
                </Link>
              </div>
              <div className="ms-2 head-icons">
                <CollapseHeader />
              </div>
            </div>
          </div>
          {/* /Breadcrumb */}
          {/* Performance Indicator list */}
          <div className="card">
            <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
              <h5>Designation List</h5>
              <div className="d-flex my-xl-auto right-content align-items-center flex-wrap row-gap-3">
                <div className="dropdown me-3">
                  <Link
                    to="#"
                    className="dropdown-toggle btn btn-white d-inline-flex align-items-center"
                    data-bs-toggle="dropdown"
                  >
                    Department {departmentFilter}
                  </Link>
                  <ul className="dropdown-menu dropdown-menu-end p-3">
                    {departmentName.map((department: any) => (
                      <li key={department.key}>
                        <Link
                          to="#"
                          className="dropdown-item rounded-1"
                          onClick={() =>
                            setDepartmentFilter(department.Department)
                          }
                        >
                          {department.Department}
                        </Link>
                      </li>
                    ))}
                  </ul>
                </div>

                <div className="dropdown me-3">
                  <Link
                    to="#"
                    className="dropdown-toggle btn btn-white d-inline-flex align-items-center"
                    data-bs-toggle="dropdown"
                  >
                    Status {statusFilter}
                  </Link>
                  <ul className="dropdown-menu dropdown-menu-end p-3">
                    <li>
                      <Link
                        to="#"
                        className="dropdown-item rounded-1"
                        onClick={() => setStatusFilter("Active")}
                      >
                        Active
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="#"
                        className="dropdown-item rounded-1"
                        onClick={() => setStatusFilter("Inactive")}
                      >
                        Inactive
                      </Link>
                    </li>
                  </ul>
                </div>
                <div className="dropdown me-3">
                  <Link
                    to="#"
                    className="dropdown-toggle btn btn-white d-inline-flex align-items-center"
                    data-bs-toggle="dropdown"
                  >
                    Sort By: {sortBy}
                  </Link>
                  <ul className="dropdown-menu dropdown-menu-end p-3">
                    <li>
                      <Link
                        to="#"
                        className="dropdown-item rounded-1"
                        onClick={() => setSortBy("Ascending")}
                      >
                        Ascending
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="#"
                        className="dropdown-item rounded-1"
                        onClick={() => setSortBy("Descending")}
                      >
                        Descending
                      </Link>
                    </li>
                  </ul>
                </div>
                <div>
                  <button
                    type="button"
                    className="btn btn-success"
                    onClick={handleReset}
                  >
                    Reset
                  </button>
                </div>
              </div>
            </div>

            <div className="card-body p-0">
              <Table
                key={JSON.stringify(filteredData)}
                dataSource={filteredData}
                columns={columns}
                Selection={false}
              />
            </div>
          </div>
          {/* /Performance Indicator list */}
        </div>
        <div className="footer d-sm-flex align-items-center justify-content-between border-top bg-white p-3">
          <p className="mb-0">2025 © CMS.</p>
          <p>
            Designed & Developed By{" "}
            <Link to="#" className="text-primary">
              ZYVO
            </Link>
          </p>
        </div>
      </div>

      {/* /Page Wrapper */}
      {/* Add Designation */}
      <div className="modal fade" id="add_designation">
        <div className="modal-dialog modal-dialog-centered modal-md">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title">Add Designation</h4>
              <button
                type="button"
                className="btn-close custom-btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <i className="ti ti-x" />
              </button>
            </div>
            <form>
              <div className="modal-body pb-0">
                <div className="row">
                  <div className="col-md-12">
                    <div className="mb-3">
                      <label className="form-label">
                        Designation Name <span className="text-danger"> *</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        name="designationName"
                        value={addDesignationFormData.designationName}
                        onChange={handleDepartmentNameChange}
                      />
                    </div>
                  </div>
                  <div className="col-md-12">
                    <div className="mb-3">
                      <label className="form-label">
                        Department Name <span className="text-danger"> *</span>
                      </label>
                      <select
                        className="form-control"
                        name="departmentId"
                        value={addDesignationFormData.departmentId}
                        onChange={handleDepartmentNameChange}
                      >
                        <option value="">Select Department</option>
                        {departmentName.map((department) => (
                          <option key={department.key} value={department.key}>
                            {department.Department}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                  <div className="col-md-12">
                    <div className="mb-3">
                      <label className="form-label">
                        Status <span className="text-danger"> *</span>
                      </label>
                      <select
                        className="form-control"
                        name="status"
                        value={addDesignationFormData.status}
                        onChange={handleDepartmentNameChange}
                      >
                        <option value="">Select</option>
                        {status.map((data) => (
                          <option key={data.value} value={data.value}>
                            {data.label}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>

                  <style>
                    {`
                    .permissions-container {
                      padding: 16px;
                      background: #f9fafb;
                      border-radius: 12px;
                      border: 1px solid #e5e7eb;
                    }

                    .section-title {
                      font-size: 18px;
                      font-weight: 600;
                      margin-bottom: 16px;
                      color: #1f2937;
                    }

                    .menu-card {
                      background: #fff;
                      border: 1px solid #e5e7eb;
                      border-radius: 8px;
                      padding: 12px;
                      margin-bottom: 16px;
                    }

                    .menu-header {
                      display: flex;
                      align-items: center;
                      font-weight: 600;
                      margin-bottom: 12px;
                    }

                    .permission-table {
                      width: 100%;
                      border-collapse: collapse;
                      font-size: 14px;
                    }

                    .permission-table th,
                    .permission-table td {
                      border: 1px solid #e5e7eb;
                      padding: 8px;
                    }

                    .permission-table th {
                      background: #f3f4f6;
                      font-weight: 500;
                      text-align: center;
                    }

                    .sub-label {
                      display: flex;
                      align-items: center;
                      gap: 6px;
                    }

                    .center-cell {
                      text-align: center;
                    }

                    input[type="checkbox"] {
                      accent-color: #2563eb;
                      transform: scale(1.1);
                      cursor: pointer;
                    }


                  `}
                  </style>

                  <div className="permissions-container">
                    <h4 className="section-title">Permissions</h4>

                    {menuSubMenu.map((menu) => (
                      <div key={menu.key} className="menu-card">
                        <div className="menu-header">
                          <input
                            type="checkbox"
                            id={`menu-${menu.key}`}
                            onChange={() => handleMenuCheckbox(menu)}
                            checked={selectedData.some(
                              (item) => item.menu === menu.title
                            )}
                            style={{ width: "30px" }}
                          />
                          <span>{menu.title}</span>
                        </div>

                        {selectedData.some(
                          (item) => item.menu === menu.title
                        ) && (
                            <table className="permission-table">
                              <thead>
                                <tr>
                                  <th style={{ width: "220px" }}>Sub Menu</th>
                                  <th style={{ width: "80px" }}>Read</th>
                                  <th style={{ width: "80px" }}>Edit</th>
                                  <th style={{ width: "80px" }}>Delete</th>
                                </tr>
                              </thead>
                              <tbody>
                                {menu.sub_menu.map((subMenu: any, index: any) => {
                                  const subItem = selectedData
                                    .find((item) => item.menu === menu.title)
                                    ?.sub_menus.find(
                                      (s: any) => s.name === subMenu
                                    );

                                  return (
                                    <tr key={index}>
                                      <td>
                                        <label className="sub-label">
                                          <input
                                            type="checkbox"
                                            id={`submenu-${menu.key}-${index}`}
                                            onChange={() =>
                                              handleSubMenuCheckbox(menu, subMenu)
                                            }
                                            checked={!!subItem}
                                            style={{ width: "30px" }}
                                          />
                                          {subMenu}
                                        </label>
                                      </td>

                                      {["Read", "Edit", "Delete"].map((perm) => (
                                        <td key={perm} className="center-cell">
                                          <input
                                            type="checkbox"
                                            id={`perm-${menu.key}-${index}-${perm}`}
                                            onChange={() =>
                                              handlePermissionChange(
                                                menu,
                                                subMenu,
                                                perm
                                              )
                                            }
                                            checked={subItem?.permissions.includes(
                                              perm
                                            )}
                                            disabled={!subItem}
                                          />
                                        </td>
                                      ))}
                                    </tr>
                                  );
                                })}
                              </tbody>
                            </table>
                          )}
                      </div>
                    ))}
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-light me-2"
                  data-bs-dismiss="modal"
                >
                  Cancel
                </button>
                <button
                  type="button"
                  data-bs-dismiss="modal"
                  className="btn btn-primary"
                  onClick={handleAddDesignation}
                >
                  Add Designation
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
      {/* /Add Designation */}

      {/* Edit Designation */}
      <div className="modal fade" id="edit_designation">
        <div className="modal-dialog modal-dialog-centered modal-md">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title">Edit Designation</h4>
              <button
                type="button"
                className="btn-close custom-btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <i className="ti ti-x" />
              </button>
            </div>
            <form>
              <div className="modal-body pb-0">
                {selectedDesignationEdit && (
                  <div className="row">
                    <div className="col-md-12">
                      <div className="mb-3">
                        <label className="form-label">Designation Name</label>
                        <input
                          type="text"
                          className="form-control"
                          value={selectedDesignationEdit.Designation || ""}
                          onChange={(e) =>
                            setSelectedDesigntionEdit((prev: any) => ({
                              ...prev,
                              Designation: e.target.value,
                            }))
                          }
                        />
                      </div>
                    </div>
                    <div className="col-md-12">
                      <div className="mb-3">
                        <label className="form-label">Department</label>
                        <CommonSelect
                          className="select"
                          options={departmentChoose}
                          defaultValue={{
                            value: selectedDesignationEdit.Department_id,
                            label: selectedDesignationEdit.Department,
                          }}
                          onChange={(selectedOption: any) =>
                            setSelectedDesigntionEdit((prev: any) => ({
                              ...prev,
                              Department: selectedOption.label,
                            }))
                          }
                        />
                      </div>
                    </div>
                    <div className="col-md-12">
                      <div className="mb-3">
                        <label className="form-label">Status</label>
                        <CommonSelect
                          className="select"
                          options={status}
                          defaultValue={{
                            value: selectedDesignationEdit.Status,
                            label: selectedDesignationEdit.Status,
                          }}
                          onChange={(selectedOption: any) =>
                            setSelectedDesigntionEdit((prev: any) => ({
                              ...prev,
                              Status: selectedOption.value,
                            }))
                          }
                        />
                      </div>
                    </div>

                    <div className="permissions-container">
                      <h4 className="section-title">Permissions</h4>
                      <div>
                        {menuSubMenu.map((menu) => (
                          <div key={menu.key} className="menu-card">
                            <div className="menu-header">
                              <input
                                type="checkbox"
                                id={`menu-${menu.key}`}
                                onChange={() => handleMenuCheckbox(menu)}
                                checked={selectedData.some(
                                  (item) => item.menu === menu.title
                                )}
                                style={{ width: "20px" }}
                              />
                              <span>{menu.title}</span>
                            </div>
                            {/* Menu Checkbox */}

                            {/* Sub-menus */}
                            {selectedData.some(
                              (item) => item.menu === menu.title
                            ) && (
                                <table className="permission-table">
                                  <thead>
                                    <tr>
                                      <th style={{ width: "220px" }}>Sub Menu</th>
                                      <th style={{ width: "80px" }}>Read</th>
                                      <th style={{ width: "80px" }}>Edit</th>
                                      <th style={{ width: "80px" }}>Delete</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {menu.sub_menu.map(
                                      (subMenu: any, index: any) => {
                                        const subItem = selectedData
                                          .find(
                                            (item) => item.menu === menu.title
                                          )
                                          ?.sub_menus.find(
                                            (s: any) => s.name === subMenu
                                          );

                                        return (
                                          <tr key={index}>
                                            <td>
                                              <label className="sub-label">
                                                <input
                                                  type="checkbox"
                                                  id={`submenu-${menu.key}-${index}`}
                                                  onChange={() =>
                                                    handleSubMenuCheckbox(
                                                      menu,
                                                      subMenu
                                                    )
                                                  }
                                                  checked={!!subItem}
                                                  style={{ width: "30px" }}
                                                />
                                                {subMenu}
                                              </label>
                                            </td>

                                            {["Read", "Edit", "Delete"].map(
                                              (perm) => (
                                                <td
                                                  key={perm}
                                                  className="center-cell"
                                                >
                                                  <input
                                                    type="checkbox"
                                                    id={`perm-${menu.key}-${index}-${perm}`}
                                                    onChange={() =>
                                                      handlePermissionChange(
                                                        menu,
                                                        subMenu,
                                                        perm
                                                      )
                                                    }
                                                    checked={subItem?.permissions.includes(
                                                      perm
                                                    )}
                                                    disabled={!subItem}
                                                  />
                                                </td>
                                              )
                                            )}
                                          </tr>
                                        );
                                      }
                                    )}
                                  </tbody>
                                </table>
                              )}
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                )}
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-light me-2"
                  data-bs-dismiss="modal"
                >
                  Cancel
                </button>
                <button
                  type="button"
                  data-bs-dismiss="modal"
                  className="btn btn-primary"
                  onClick={handleEditSaveChanges}
                >
                  Save Changes
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
      {/* /Edit Department */}

      <EmployeeDetailsModal
        isOpen={showEmployeeModal}
        onClose={() => setShowEmployeeModal(false)}
        users={selectedUsers}
        designation={selectedDesignation}
      />
      <DeleteModal
        modalId="delete_modal"
        onDelete={handleDelete}
        title="Delete Item"
        message="Are you sure you want to delete this item? This action cannot be undone."
      />
    </>
  );
};

export default Designations;
